import { map } from 'lodash/fp';

import createReducer from '../utils/createReducer';
import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from '../constants/actionTypes';
import { COUNTRIES } from '../constants/apiTypes';

const mapCountries = map(c => ({
  alpha2: c.iso_alpha_2_code,
  alpha3: c.iso_alpha_3_code,
  id: c.id,
  name: c.name,
  phonePrefix: c.calling_code
}));

const initialState = {
  errors: [],
  items: [],
  isFetching: false
};

const staticContentReducer = createReducer(initialState, {
  [API_CALL_REQUEST]: (state, action) =>
    action.api === COUNTRIES
      ? {
          isFetching: true
        }
      : undefined,

  [API_CALL_SUCCESS]: (state, action) =>
    action.api === COUNTRIES
      ? {
          items: mapCountries(action.data)
        }
      : undefined,

  [API_CALL_FAILURE]: (state, action) =>
    action.api === COUNTRIES
      ? {
          errors: action.errors
        }
      : undefined
});

export default staticContentReducer;
